import { takeLatest, put, all, call } from 'redux-saga/effects'
import currenciesTypes from 'redux/currencies/currencies-types'
import * as currenciesActions from 'redux/currencies/currencies-actions'
import { getRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { getXCurrencies } from '../currencies/currencies-state'

function* startGetCurrencies() {
    try {
        const { data: assets } = yield getRequest('/user/assets')
        yield put(currenciesActions.successGetCurrencies(getXCurrencies(assets)))
    } catch (err) {
        yield put(currenciesActions.failureGetCurrencies())
        if (!IS_PRODUCTION) {
            console.log('err fetching cards', err?.response?.data)
        }
    }
}

export function* onStartGetCurrencies() {
    yield takeLatest(currenciesTypes.START_GET_CURRENCIES, startGetCurrencies)
}

export function* currenciesSagas() {
    yield all([call(onStartGetCurrencies)])
}
